import Commands from './commands';

class IncrBy extends Commands {
    constructor(registry) {
        super("incrBy", registry);
    }

    async execute(node, emitter, options) {
        const key = await emitter(node.params[0], options);
        const increment = parseFloat(await emitter(node.params[1], options));
        const value = parseFloat(this.registry.get(key));
        this.registry.set(key, value + increment);
        return value + increment;
    }
}

export default IncrBy;
